var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep1112(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 165,
    viewBox: "0 0 30 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3776 157.707C26.7682 157.317 26.7682 156.683 26.3776 156.293L20.0137 149.929C19.6231 149.538 18.99 149.538 18.5995 149.929C18.2089 150.319 18.2089 150.953 18.5995 151.343L24.2563 157L18.5995 162.657C18.2089 163.047 18.2089 163.681 18.5995 164.071C18.99 164.462 19.6231 164.462 20.0137 164.071L26.3776 157.707ZM30 0H11V2H30V0ZM0 11V147H2V11H0ZM11 158H25.6705V156H11V158ZM0 147C0 153.075 4.92487 158 11 158V156C6.02944 156 2 151.971 2 147H0ZM11 0C4.92487 0 0 4.92487 0 11H2C2 6.02944 6.02944 2 11 2V0Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep1112);
export default __webpack_public_path__ + "static/media/laptop_step_11_12.3e2e2e093a78144e91d43a9c7a40ed7b.svg";
export { ForwardRef as ReactComponent };